import React from 'react';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';

export const FooterLink = ({ text, ...props }) => (
  <Link
    color="inherit"
    underline="hover"
    dangerouslySetInnerHTML={props.children ? null : { __html: text }}
    {...props}
  />
);

FooterLink.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
};

export default FooterLink;
